import React from "react";
import {GoogleMap, withGoogleMap, withScriptjs} from "react-google-maps";
import {GOOGLE_MAPS_API_KEY} from "../../../config";
import {DEFAULT_STYLE} from "./mapStyles";
import FeatureCollection from "./FeatureCollection";
import CoordinatesAssembler from "./CoordinatesAssembler";

const MapWrapper = withScriptjs(
    withGoogleMap(props => (
        <GoogleMap
            defaultOptions={{
                scrollwheel: true,
                styles: DEFAULT_STYLE
            }}
            ref={map => {
                const bounds = new window.google.maps.LatLngBounds();
                const {coordinates} = props;
                coordinates.forEach(coordinate => {
                    bounds.extend(new window.google.maps.LatLng(coordinate.lat, coordinate.lng));
                });
                map.fitBounds(bounds);
            }}
        >
            <FeatureCollection data={props.data}/>
        </GoogleMap>
    ))
);

const Map = ({data: jsonData}) => {
    const data = jsonData.data[0]; //TODO: should have been a key because only one child here but not a priority
    const {features} = data;
    const coordinatesAssembler = new CoordinatesAssembler();
    const coordinates = coordinatesAssembler.toCoordinatesLatLng(features);
    return (
        <div className="map">
            <MapWrapper
                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}`}
                loadingElement={<div style={{height: `100%`}}/>}
                containerElement={<div style={{height: `100%`}}/>}
                mapElement={<div style={{height: `100%`}}/>}
                data={data}
                coordinates={coordinates}
            />
        </div>
    );
};

export default Map;